import { Formik, Field } from "formik";
import React from "react";
import ErrorFocus from './ErrorFocus';
import * as Yup from "yup";
import './RegistrationForm.css';
import moment from 'moment-timezone';
import { Row, Col, Modal, Image, Alert } from 'react-bootstrap';
import 'react-credit-cards/es/styles-compiled.css';
import Payment from 'payment';
import { LessonMeetingAddresses } from '../../components/contstants/Locations';
import './Form.css';
import Cards from 'react-credit-cards';
import {
    InputFeedback,
    TextInput,
    DOBTextInput,
    CCTextInput,
    Checkbox,
    addCompletionCertificateCheckBox,
    RadioButtonGroup
} from './RegistrationFormInputs';
import {
    drivingSchool,
    sourceOptions,
    RadioButtonDateLocation,
    DrivingSchoolRadioButtonChoice,
    RoadTestLessonDisplayButton,
    RoadTestRadioButtonChoice,
    FormikSelect,
    FormikSelectRoadLessonDate,
    FormikAddLesson,
    FormikSelectRoadLessonDateSlot
} from './RegistrationFormSelects';

moment.tz.setDefault("America/New_York");


class RegistrationForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            roadTestDates: [],
            avaliableOptions: [],
            loading: false,
            showConfirmation: false,
            lessonsNeeded: 0,
            selectedLessons: [],
            apiResponseError: "",
            roadTestDatesFile: {}
        };
        this.formikRef = React.createRef();
    }
    handleHide = () => {
        this.setState({ loading: false });
    };

    handleErrors = (response) => {
        if (!response.ok) {
            console.log(response.statusText);
        }
        return response;
    };
    responseHandler = (response) => {
        try {
            let formikVals = this.formikRef.current.values;
            if (response.messages.resultCode === "Error") {
                this.setState({ loading: false });
                this.formikRef.current.setSubmitting(false);
                let i = 0;
                while (i < response.messages.message.length) {
                    console.log(
                        response.messages.message[i].code + ": " +
                        response.messages.message[i].text
                    );
                    i = i + 1;
                }
            }
            else {
                //The Authorize NET request was successful!
                //To handle how different browsers handle date input. AKA IE
                let parsedDOBDate = moment();
                let parsedPermitDate = moment();
                if (moment(formikVals.dateOfBirth, "M/D/YYYY", true).isValid()) {
                    parsedDOBDate = moment(formikVals.dateOfBirth, "M/D/YYYY", true);
                }
                else if (moment(formikVals.dateOfBirth, "M/D/YY", true).isValid()) {
                    parsedDOBDate = moment(formikVals.dateOfBirth, "M/D/YY", true);
                }
                else {
                    parsedDOBDate = moment(formikVals.dateOfBirth, "YYYY-MM-DD", true);
                }
                if (moment(formikVals.permitIssueDate, "M/D/YYYY", true).isValid()) {
                    parsedPermitDate = moment(formikVals.permitIssueDate, "M/D/YYYY", true);
                }
                else if (moment(formikVals.permitIssueDate, "M/D/YY", true).isValid()) {
                    parsedPermitDate = moment(formikVals.permitIssueDate, "M/D/YY", true);
                }
                else {
                    parsedPermitDate = moment(formikVals.permitIssueDate, "YYYY-MM-DD", true);
                }
                const self = this;
                let nonce = response.opaqueData.dataValue;
                let body = {
                    fName: formikVals.firstName,
                    lName: formikVals.lastName,
                    dob: parsedDOBDate.format("YYYY-MM-DD"),
                    permitNo: formikVals.permitNumber,
                    permitDate: parsedPermitDate.format("YYYY-MM-DD"),
                    email: formikVals.email,
                    parentEmail: formikVals.parentEmail,
                    phone: formikVals.phoneNumber,
                    package: formikVals.roadTestPackage,
                    roadTestChoiceDate: formikVals.roadTestDateOption,
                    drivingSchool: formikVals.drivingSchool,
                    nonce: nonce,
                    source: Object.keys(formikVals.source).length > 0
                        ? (formikVals.source.value === "Other" ? `Other - (${formikVals.sourceText})` : formikVals.source.label)
                        : "None Specified",
                    sourceText: formikVals.sourceText || "",
                    CCFirstName: formikVals.CCFirstName,
                    CCLastName: formikVals.CCLastName,
                    CCAddress: formikVals.CCAddress,
                    CCCity: formikVals.CCCity,
                    CCState: formikVals.CCState,
                    CCZip: formikVals.CCZip,
                    CCCountry: formikVals.CCCountry,
                    addCompletionCertificate: formikVals.addCompletionCertificate,
                    location: formikVals.location
                };

                if (formikVals.lessonsNeeded > 0) {
                    body["selectedLessonChoices"] = formikVals.selectedLessonChoices;
                }

                fetch('https://x4g3mwhate.execute-api.us-east-1.amazonaws.com/dev/submitpayment', {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    method: 'post',
                    body: JSON.stringify(body)
                })
                    .then(function (response) {
                        return response.json();
                    }).then(function (data) {
                        if (data.type === 'success') {
                            self.formikRef.current.resetForm();
                            self.setState({
                                loading: false,
                                showConfirmation: true,
                            });
                        }
                        else {
                            self.setState({ loading: false });
                            self.formikRef.current.setSubmitting(false);
                            if (["Transaction Failed with error code 2 : This transaction has been declined.", "Transaction Failed with error code 65 : This transaction has been declined."].includes(data.message)) {
                                self.formikRef.current.setErrors({
                                    apiResponseError: "There was an issue processing your card. Please double check your credit card entries."
                                });
                            }
                            else {
                                self.formikRef.current.setErrors(
                                    {
                                        apiResponseError: data.message
                                    }
                                );
                            }
                        }
                    }
                    ).catch(function () {
                        self.setState({ loading: false });
                        self.formikRef.current.setSubmitting(false);
                        self.formikRef.current.setErrors({
                            apiResponseError: "A network error occurred. Please try again."
                        });
                    });
            }
        } catch (error) {
            this.setState({ loading: false });
            console.log(error);
        }
    };

    bindSubmitForm = (values, { setErrors, setSubmitting }) => {
        const errors = {};
        //Now we need additional proccessing to make sure the form is valid.
        const validNumber = Payment.fns.validateCardNumber(values.CCNumber);
        const validExpiration = Payment.fns.validateCardExpiry(values.CCExpiration);
        const validCVC = Payment.fns.validateCardCVC(values.CCCode);
        if (!validNumber) {

            errors.CCNumber = "This number is not a valid credit card number.";
        }
        else {
            const cardType = Payment.fns.cardType(values.CCNumber);
            if (cardType !== "visa" && cardType !== "mastercard" && cardType !== "discover") {
                errors.CCNumber = "Sorry, we only accept Visa, Mastercard, and Discover.";
            }
        }
        if (!validExpiration) {
            errors.CCExpiration = "Invalid Expiration Date";
        }
        if (!validCVC) {
            errors.CCCode = "Invalid CVC Code";
        }

        if (moment(values.dateOfBirth, "M/D/YYYY", true).isValid() || moment(values.dateOfBirth, "M/D/YY", true).isValid() || moment(values.dateOfBirth, "YYYY-MM-DD", true).isValid()) {
            let parsedDate = moment();
            if (moment(values.dateOfBirth, "M/D/YYYY", true).isValid()) {
                parsedDate = moment(values.dateOfBirth, "M/D/YYYY", true);
            }
            else if (moment(values.dateOfBirth, "M/D/YY", true).isValid()) {
                parsedDate = moment(values.dateOfBirth, "M/D/YY", true);
            }
            else {
                parsedDate = moment(values.dateOfBirth, "YYYY-MM-DD", true);
            }

            if (parsedDate.isAfter(moment()) || parsedDate.clone().add(16, 'years').isAfter(moment())) {
                errors.dateOfBirth = "You're a bit too young to try to book a road test. Come back when you're old enough.";

            }
            else if (parsedDate.isBefore(moment().subtract(150, 'years'))) {
                errors.dateOfBirth = "Wow, you're over 150 years old. Please contact us directly to book your road test.";
            }
        }
        else {
            errors.dateOfBirth = "Invalid Date of Birth Format. Please enter it in MM/DD/YYYY form.";
        }

        if (moment(values.permitIssueDate, "M/D/YYYY", true).isValid() || moment(values.permitIssueDate, "M/D/YY", true).isValid() || moment(values.permitIssueDate, "YYYY-MM-DD", true).isValid()) {
            let parsedPermitDate = moment();
            if (moment(values.permitIssueDate, "M/D/YYYY", true).isValid()) {
                parsedPermitDate = moment(values.permitIssueDate, "M/D/YYYY", true);
            }
            else if (moment(values.permitIssueDate, "M/D/YY", true).isValid()) {
                parsedPermitDate = moment(values.permitIssueDate, "M/D/YY", true);
            }
            else {
                parsedPermitDate = moment(values.permitIssueDate, "YYYY-MM-DD", true);
            }

            if (parsedPermitDate.isBefore(moment().subtract(2, "years"))) {
                errors.permitIssueDate = "It looks like your permit has expired.";
            }
            else if (parsedPermitDate.isAfter(moment())) {
                errors.permitIssueDate = "You can't have a permit issued from the FUTURE.";
            }
            if (values.roadTestDateOption) {
                if (parsedPermitDate.isAfter(moment(values.roadTestDateOption).subtract(6, "months"))) {
                    if (moment(values.dateOfBirth, "M/D/YYYY", true).isValid() || moment(values.dateOfBirth, "M/D/YY", true).isValid() || moment(values.dateOfBirth, "YYYY-MM-DD", true).isValid()) { //Check if date is valid
                        let birthDate = moment();
                        if (moment(values.dateOfBirth, "M/D/YYYY", true).isValid()) {
                            birthDate = moment(values.dateOfBirth, "M/D/YYYY", true);
                        }
                        else if (moment(values.dateOfBirth, "M/D/YY", true).isValid()) {
                            birthDate = moment(values.dateOfBirth, "M/D/YY", true);
                        }
                        else {
                            birthDate = moment(values.dateOfBirth, "YYYY-MM-DD", true);
                        }
                        if (!birthDate.isBefore(moment().subtract(18, "years"))) { //6 month restriction only applies to 16 and a half to 18
                            errors.permitIssueDate = "As a junior operator, you need to have your permit for a minimum of 6 months prior to a road test.";
                        }
                    }
                    else { //Date's not valid
                        errors.dateOfBirth = "Invalid Date of Birth Format. Please enter it in MM/DD/YYYY form.";
                    }
                }
                if (moment(values.roadTestDateOption).subtract(2, "years").isAfter(parsedPermitDate)) {
                    errors.permitIssueDate = "Your permit is two years older than the road test requested, and wouldn't be able to be used for that road test.";
                }
            }
        }
        else {
            errors.permitIssueDate = "Invalid Permit Issue Date Format. Please enter it in MM/DD/YYYY form.";
        }
        if (moment(values.roadTestDateOption).isBefore(moment())) {
            errors.roadTestDateOption = "You can not book a road test in the past! Please choose another date.";
        }

        if (values.lessonsNeeded > values.selectedLessonChoices.length) {
            errors.lessonDate = "You haven't selected enough lessons!";
        }
        if (values.selectedLessonChoices.length > values.lessonsNeeded) {
            errors.lessonDate = "You have too many selected lessons. Please remove one!";
        }


        if (!values.email.includes("@")) {
            errors.email = "Please enter a valid email address.";
        }
        if (!values.confemail.includes("@")) {
            errors.confemail = "Please enter a valid confirmation email address.";
        }
        if (!errors.email && !errors.confemail && values.email !== values.confemail) {
            errors.email = "Both your email addresses must match.";
            errors.confemail = "Both your email addresses must match.";
        }

        if (values.showParentConf) {
            if (values.parentEmail && !values.parentEmail.includes("@")) {
                errors.parentEmail = "Please enter a valid parent email address.";
            }
            if (values.confParentEmail && !values.confParentEmail.includes("@")) {
                errors.confParentEmail = "Please enter a valid parent confirmation email address.";
            }
            if (!errors.parentEmail && !errors.confParentEmail &&
                values.parentEmail && values.confParentEmail &&
                values.parentEmail !== values.confParentEmail) {
                errors.parentEmail = "Both your parent's email addresses must match.";
                errors.confParentEmail = "Both your parent's email addresses must match.";
            }
        }

        if (values.phoneNumber.length !== 10) {
            errors.phoneNumber = "Invalid phone number.";
        }
        if (values.roadTestDateOption) {
            const isWeekdayDate = moment(values.roadTestDateOption).day() !== 6;
            if (isWeekdayDate && !values.roadTestPackage.includes("Weekday")) {
                errors.roadTestPackage = "Weekday road tests require a Weekday at RMV package.";
            }
            if (!isWeekdayDate && values.roadTestPackage.includes("Weekday")) {
                errors.roadTestPackage = "The Weekday at RMV package is only available for weekday road tests.";
            }
        }
        setErrors(errors);
        if (Object.keys(errors).length > 0) {
            setSubmitting(false);
            return;
        }
        //SANDBOX
        //var authData = {
        //    clientKey: "5KP3WdKyu8vrxHcpBMD96TsDknJZG36MyazkM9Z9sUa6ja7Mq7e5L2uVN8675ZnE",
        //    apiLoginID: "7j3Mq5W6"
        //};

        //PROD
        const authData = {
            clientKey: "62CpRk5LpV9a3ZVd3r9ngCk3Uw3Le4ZDAJ8fL8E8n4xMQ653P2hWtGV89HbC22eU",
            apiLoginID: "2w2YM4z9p"
        };

        const cardData = {
            cardNumber: values.CCNumber.replace(/\s/g, ''),
            month: values.CCExpiration.substring(0, 2),
            year: values.CCExpiration.substring(values.CCExpiration.length - 2, values.CCExpiration.length),
            cardCode: values.CCCode,
            zip: values.CCZip,
            fullName: values.CCFirstName + " " + values.CCLastName
        };
        const secureData = {
            authData: authData,
            cardData: cardData
        };
        this.setState({ loading: true });
        try {
            window.Accept.dispatchData(secureData, this.responseHandler);
        } catch (error) {
            this.setState({ loading: false });
            console.log(error);
        }
    };

    componentDidMount() {
        const script = document.createElement("script");
        //SANDBOX
        //script.src = "https://jstest.authorize.net/v1/Accept.js";

        //PROD
        script.src = "https://js.authorize.net/v1/Accept.js";
        script.async = true;


        document.body.appendChild(script);
        const that = this;
        //We need to grab stuff
        fetch('https://s3.amazonaws.com/publicdates/roadTestDates.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'GET'
        })
            .then(this.handleErrors)
            .then(function (response) {
                return response.json();
            }).then(function (data) {
                data = JSON.parse(data);
                //console.log(data)
                const roadTestDates = Object.keys(data).map(x => moment(x)).sort(function (a, b) { return a - b; });
                that.setState({ roadTestDates, roadTestDatesFile: data });

            });

        fetch('https://s3.amazonaws.com/publicdates/roadTestPackages.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'GET'
        })
            .then(this.handleErrors)
            .then(function (response) {
                return response.json();
            }).then(function (data) {
                //console.log(data)
                that.setState({ avaliableOptions: data });
            });

        const option = this.props.match.params.option;
        if (option === "RTO") {
            this.setState({ roadTestPackageOption: "Road Test Only ($140)" });
            window.scrollTo(0, 0);
        }
        else if (option === "RTOL") {
            this.setState({ roadTestPackageOption: "Road Test w/ One Lesson ($210)", lessonsNeeded: 1 });
            window.scrollTo(0, 0);
        }
    }
    render() {
        const regFormContent = (
            <div className="app">
                <Formik
                    initialValues={{
                        roadTestPackage: this.state.roadTestPackageOption ? this.state.roadTestPackageOption : "", lessonsNeeded: this.state.lessonsNeeded, drivingSchool: "", roadTestDateOption: "", drivingSchoolChoice: "",
                        dateOfBirth: '', firstName: '', lastName: '', confemail: '', email: '', parentEmail: '', phoneNumber: "", permitNumber: "", permitIssueDate: "",
                        source: {}, fullRoadTestDateOption: "",
                        CCNumber: '', CCFirstName: '', CCLastName: '', CCExpiration: '', CCCode: '', focused: '',
                        CCAddress: '', CCCity: '', CCState: '', CCZip: '', CCCountry: 'USA',
                        confirmCheck: false, addCompletionCertificate: false, fetchedLessons: {}, selectedDayLessonOptions: [], selectedLessonChoices: [], showParentConf: false
                    }}
                    innerRef={this.formikRef}
                    onSubmit={this.bindSubmitForm}
                    validateOnChange={true}
                    validationSchema={
                        Yup.object().shape({
                            fullRoadTestDateOption: Yup.string()
                                .required('Please indicate which road test date you would like'),
                            roadTestPackage: Yup.string()
                                .min(2, 'Too Short!')
                                .required('Please indicate which driving package you would like'),
                            source: Yup.object().shape({
                                value: Yup.string()
                                    .required("Won't you tell us how you heard about us?")
                            }),
                            sourceText: Yup.string()
                                .min(2, 'Too Short!')
                                .required('Please specify where you heard about us'),
                            drivingSchoolChoice: Yup.string()
                                .min(2, 'Too Short!')
                                .required('Please specify your driving school'),
                            drivingSchool: Yup.string()
                                .min(2, 'Too Short!')
                                .required('Please specify your driving school'),
                            firstName: Yup.string()
                                .min(2, 'Too Short!')
                                .required('A first name is required'),
                            lastName: Yup.string()
                                .min(2, 'Too Short!')
                                .required('A last name is required'),
                            dateOfBirth: Yup.date().typeError("Invalid date")
                                .required('A date of birth is required'),
                            permitNumber: Yup.string()
                                .min(2, 'Too Short!')
                                .required('A permit number is required'),
                            permitIssueDate: Yup.date().typeError("Invalid date")
                                .required('A permit issue date is required'),
                            email: Yup.string()
                                .min(2, 'Too Short!')
                                .required('An email is required'),
                            confemail: Yup.string()
                                .min(2, 'Too Short!')
                                .required('Please retype in your email'),
                            parentEmail: Yup.string()
                                .test('parent-email-format', 'Please enter a valid parent email address.',
                                    value => !value || value.includes('@')),
                            confParentEmail: Yup.string()
                                .test('conf-parent-email-format', 'Please enter a valid parent confirmation email address.',
                                    value => !value || value.includes('@')),
                            phoneNumber: Yup.string()
                                .min(10, 'Too Short!')
                                .required('A phone number is required'),
                            CCNumber: Yup.string()
                                .min(10, 'Too Short!')
                                .required('A credit card number is required'),
                            CCFirstName: Yup.string()
                                .min(2, 'Too Short!')
                                .required('First name is required'),
                            CCLastName: Yup.string()
                                .min(2, 'Too Short!')
                                .required('Last name is required'),
                            CCCode: Yup.number().typeError("Invalid number")
                                .required('The CVC code is required'),
                            CCAddress: Yup.string()
                                .min(2, 'Too Short!')
                                .required('The billing address is required'),
                            CCExpiration: Yup.string().min(7, 'Too Short!')
                                .required('The expiration of the card is required'),
                            CCCity: Yup.string()
                                .min(2, 'Too Short!')
                                .required('The billing city is required'),
                            CCState: Yup.string()
                                .min(2, 'Too Short!')
                                .required('The billing state is required'),
                            CCZip: Yup.string()
                                .min(5, 'Too Short!')
                                .required('The billing zipcode is required'),
                            CCCountry: Yup.string()
                                .min(3, 'Too Short!')
                                .required('The billing country is required'),
                            confirmCheck: Yup.bool().oneOf([true], "You have to agree!")
                        })}
                >
                    {props => {
                        const {
                            values,
                            touched,
                            errors,
                            handleChange,
                            handleSubmit,
                            setFieldValue,
                            setFieldTouched,
                            isSubmitting,
                            submitCount
                        } = props;
                        return (
                            <form onSubmit={handleSubmit}>
                                <ErrorFocus />
                                <RadioButtonGroup
                                    id="fullRoadTestDateOption"
                                    label="Preferred Date (Subject to RMV availability)"
                                    sublabel="Although we usually get the date we request, all dates are subject to RMV availability."
                                    value={values.fullRoadTestDateOption}
                                    error={errors.fullRoadTestDateOption}
                                    touched={touched.fullRoadTestDateOption}
                                    onChange={setFieldValue}
                                    onBlur={setFieldTouched}
                                >

                                    {this.state.roadTestDates.filter(x => moment(x).isAfter(moment()))
                                        .sort(function (a, b) { return a - b; })
                                        .map((roadTestDate, index) => {
                                            const parsedDate = roadTestDate.toISOString();
                                            let locations = [];
                                            if (this.state.roadTestDatesFile[parsedDate] && this.state.roadTestDatesFile[parsedDate].locations) {
                                                locations = this.state.roadTestDatesFile[parsedDate].locations;
                                            }
                                            if (roadTestDate.day() === 6) {
                                                return (
                                                    locations.map((location, key) => {
                                                        return (
                                                            <Field
                                                                key={roadTestDate + location + key}
                                                                component={RadioButtonDateLocation}
                                                                date={roadTestDate.format("YYYY-MM-DD")}
                                                                location={location}
                                                                name="fullRoadTestDateOption"
                                                                id={roadTestDate.format("YYYY-MM-DD") + "|" + location}
                                                                label={"Saturday " + moment(roadTestDate).format('M/D') + " at " + location}
                                                            />
                                                        );
                                                    })
                                                );
                                            }
                                            else {
                                                return (
                                                    locations.map((location, key) => {
                                                        if (location.includes("RMV")) {
                                                            return (
                                                                <Field
                                                                    key={roadTestDate + location + key}
                                                                    component={RadioButtonDateLocation}
                                                                    date={roadTestDate.format("YYYY-MM-DD")}
                                                                    location={location}
                                                                    name="fullRoadTestDateOption"
                                                                    id={roadTestDate.format("YYYY-MM-DD") + "|" + location}
                                                                    label={"Weekday of " + moment(roadTestDate).format('M/D (ddd)') + " at " + location} />
                                                            );
                                                        } else {
                                                            return (
                                                                <Field
                                                                    key={roadTestDate + location + key}
                                                                    component={RadioButtonDateLocation}
                                                                    date={roadTestDate.format("YYYY-MM-DD")}
                                                                    location={location}
                                                                    name="fullRoadTestDateOption"
                                                                    id={roadTestDate.format("YYYY-MM-DD") + "|" + location}
                                                                    label={"Weekday of " + moment(roadTestDate).format('ddd M/D') + " at " + location} />
                                                            );
                                                        }
                                                    })
                                                );
                                            }
                                        })
                                    }

                                </RadioButtonGroup>
                                <RadioButtonGroup
                                    id="roadTestPackage"
                                    label="Road Test Package"
                                    value={values.roadTestPackage}
                                    error={errors.roadTestPackage}
                                    touched={touched.roadTestPackage}
                                >
                                    {!values.roadTestDateOption
                                        ? <p className="input-feedback">Please select a preferred road test date to view available packages.</p>
                                        : this.state.avaliableOptions
                                            .filter(roadTestPackage => {
                                                const isWeekday = moment(values.roadTestDateOption).day() !== 6;
                                                return isWeekday
                                                    ? roadTestPackage.package.includes("Weekday")
                                                    : !roadTestPackage.package.includes("Weekday");
                                            })
                                            .map((roadTestPackage, key) => {
                                                return (
                                                    <RoadTestRadioButtonChoice
                                                        key={roadTestPackage.package + key}
                                                        name="roadTestPackage"
                                                        id={roadTestPackage.package + " ($" + roadTestPackage.price + ")"}
                                                        label={roadTestPackage.package + " ($" + roadTestPackage.price + ")"}
                                                        value={values.roadTestPackage}
                                                        package={roadTestPackage}
                                                        onChange={setFieldValue}
                                                        onBlur={setFieldTouched}
                                                    />
                                                );
                                            })
                                    }
                                </RadioButtonGroup>
                                {values.lessonsNeeded > 0 ?
                                    <div style={{ margin: "1rem 0" }}>
                                        <label htmlFor="color">Requested Lesson Times</label>

                                        {values.roadTestDateOption ?
                                            <div>
                                                <div>Please select your {values.lessonsNeeded} lesson{values.lessonsNeeded === 1 ? "" : "s"}</div>
                                                {values.selectedLessonChoices.length > 0 ?

                                                    <div>

                                                        {values.selectedLessonChoices.map((selectedLesson, key) => {
                                                            let dow = moment(selectedLesson.date).format('dddd');

                                                            return (
                                                                <RoadTestLessonDisplayButton
                                                                    key={selectedLesson.date + selectedLesson.slot}
                                                                    name="roadTestPackage"
                                                                    id={selectedLesson.date + selectedLesson.slot}
                                                                    label={dow + " " + moment(selectedLesson.date).format('MM/DD/YYYY') + " at " + selectedLesson.slot + " at " + selectedLesson.location + "  "}
                                                                    onChange={setFieldValue}
                                                                    onBlur={setFieldTouched}
                                                                    selectedLesson={selectedLesson}
                                                                    values={values.selectedLessonChoices}
                                                                />
                                                            );
                                                        })}
                                                    </div>
                                                    :

                                                    <div>Hmm... You haven't selected any times yet.</div>

                                                }
                                                {errors.lessonDate ? <InputFeedback error={errors.lessonDate} /> : null}
                                                {values.lessonsNeeded > values.selectedLessonChoices.length ?
                                                    <div>
                                                        <label htmlFor="color">Date of Lesson</label>

                                                        <FormikSelectRoadLessonDate
                                                            id="lessonDate"
                                                            onChange={setFieldValue}
                                                            onBlur={setFieldTouched}
                                                            selectedDay={values.roadTestDateOption}
                                                            location={values.location}
                                                            fetchedLessons={values.fetchedLessons}
                                                        />
                                                        {values.lessonDate ?
                                                            <div>
                                                                <label htmlFor="color">Time Slot of Lesson</label>
                                                                <FormikSelectRoadLessonDateSlot
                                                                    id="lessonDateSlot"
                                                                    onChange={setFieldValue}
                                                                    onBlur={setFieldTouched}
                                                                    selectedDay={values.lessonDate}
                                                                    selectedDayLessonOptions={values.selectedDayLessonOptions}
                                                                />
                                                                {values.lessonDateSlot && LessonMeetingAddresses[values.lessonDateSlot.location] ?
                                                                    <div style={{ fontWeight: "bold", margin: "0.5rem 0" }}>
                                                                        You will meet the instructor at {LessonMeetingAddresses[values.lessonDateSlot.location]}.
                                                                    </div> : null
                                                                }
                                                            </div> : null
                                                        }

                                                        {values.lessonDateSlot ?
                                                            <FormikAddLesson
                                                                id="addLessonButton"
                                                                onChange={setFieldValue}
                                                                onBlur={setFieldTouched}
                                                                lessonDate={values.lessonDate}
                                                                lessonDateSlot={values.lessonDateSlot}
                                                                selectedLessonChoices={values.selectedLessonChoices}
                                                            />

                                                            : null}
                                                        <div>Note: Lessons are not allowed on road test days.</div>                                                    </div>
                                                    : null}
                                            </div> : <div>Please select a preferred road test date to view available lesson dates.</div>
                                        }

                                    </div> : null
                                }

                                <RadioButtonGroup
                                    id="drivingSchoolChoice"
                                    label="Driving School Attended"
                                    value={values.drivingSchoolChoice}
                                    error={errors.drivingSchoolChoice}
                                    touched={touched.drivingSchoolChoice}
                                >
                                    {drivingSchool.map((drivingSchoolRadio, key) => {
                                        return (
                                            <DrivingSchoolRadioButtonChoice
                                                key={drivingSchoolRadio.value + key}
                                                name="drivingSchool"
                                                id={drivingSchoolRadio.value}
                                                label={drivingSchoolRadio.label}
                                                value={values.drivingSchoolChoice}
                                                onChange={setFieldValue}
                                                onBlur={setFieldTouched}
                                            />
                                        );
                                    })}
                                </RadioButtonGroup>

                                {values.drivingSchoolChoice === "Parkway Driving School" ?
                                    <Field
                                        component={addCompletionCertificateCheckBox}
                                        name="addCompletionCertificate"
                                        id="addCompletionCertificate"
                                        value={values.addCompletionCertificate}
                                    /> : null}



                                {values.drivingSchoolChoice === "Other Driving School" ?
                                    <TextInput
                                        id="drivingSchool"
                                        type="text"
                                        label="Other Driving School Name"
                                        placeholder="Enter other driving school name"
                                        error={errors.drivingSchool}
                                        value={values.drivingSchool}
                                        onChange={handleChange}
                                        onBlur={setFieldTouched}
                                        touched={touched.drivingSchool}
                                    /> : null}
                                <FormikSelect
                                    id="source"
                                    options={sourceOptions}
                                    value={values.source}
                                    onChange={setFieldValue}
                                    onBlur={setFieldTouched}
                                    error={errors.source}
                                    touched={touched.source}
                                />
                                {values.source && values.source.value === "Other" ?
                                    <TextInput
                                        id="sourceText"
                                        type="text"
                                        label="Other Source"
                                        placeholder="Enter other source"
                                        error={errors.sourceText}
                                        value={values.sourceText}
                                        onChange={handleChange}
                                        onBlur={setFieldTouched}
                                        touched={touched.sourceText}
                                    /> : null}

                                <Row>
                                    <Col>
                                        <TextInput
                                            id="firstName"
                                            type="text"
                                            label="Full Legal First Name (of the individual taking the exam)"
                                            placeholder="Enter text"
                                            error={errors.firstName}
                                            value={values.firstName}
                                            onChange={handleChange}
                                            onBlur={setFieldTouched}
                                            touched={touched.firstName}
                                        />
                                    </Col>
                                    <Col>
                                        <TextInput
                                            id="lastName"
                                            type="text"
                                            label="Full Legal Last Name (of the individual taking the exam)"
                                            placeholder="Enter text"
                                            error={errors.lastName}
                                            value={values.lastName}
                                            onChange={handleChange}
                                            onBlur={setFieldTouched}
                                            touched={touched.lastName}
                                        />
                                    </Col>
                                </Row>
                                <DOBTextInput
                                    id="dateOfBirth"
                                    type="date"
                                    label="Date of Birth (of the individual taking the exam)"
                                    placeholder="MM/DD/YYYY"
                                    setFieldValue={setFieldValue}
                                    error={errors.dateOfBirth}
                                    value={values.dateOfBirth}
                                    onChange={handleChange}
                                    onBlur={setFieldTouched}
                                    touched={touched.dateOfBirth}

                                />
                                <div>{"Example: 01/01/2000"}</div>
                                <Row>
                                    <Col>
                                        <TextInput
                                            id="permitNumber"
                                            type="text"
                                            label="Permit Number"
                                            placeholder="e.g. SA1234567"
                                            error={errors.permitNumber}
                                            value={values.permitNumber}
                                            onChange={handleChange}
                                            onBlur={setFieldTouched}
                                            touched={touched.permitNumber}

                                        />
                                    </Col>
                                    <Col>
                                        <TextInput
                                            id="permitIssueDate"
                                            type="date"
                                            label="Permit Issue Date"
                                            placeholder="MM/DD/YYYY"
                                            error={errors.permitIssueDate}
                                            value={values.permitIssueDate}
                                            onChange={handleChange}
                                            onBlur={setFieldTouched}
                                            touched={touched.permitIssueDate}

                                        /> <div>{"Example: 01/01/2000"}</div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <TextInput
                                            id="email"
                                            type="text"
                                            label="Email"
                                            placeholder="Enter Text"
                                            error={touched.email && errors.email}
                                            value={values.email}
                                            onChange={handleChange}
                                            onBlur={setFieldTouched}
                                            touched={touched.email}
                                        />
                                    </Col>
                                    <Col>
                                        <TextInput
                                            id="confemail"
                                            type="text"
                                            label="Confirm Email"
                                            placeholder="Enter Text"
                                            error={errors.confemail}
                                            value={values.confemail}
                                            onChange={handleChange}
                                            onBlur={setFieldTouched}
                                            touched={touched.confemail}
                                        />
                                    </Col>
                                </Row>
                                {values.showParentConf ?
                                    <Row>
                                        <Col>
                                            <TextInput
                                                id="parentEmail"
                                                type="text"
                                                label="Parent Email"
                                                placeholder="Enter Text"
                                                error={touched.parentEmail && errors.parentEmail}
                                                value={values.parentEmail}
                                                onChange={handleChange}
                                                onBlur={setFieldTouched}
                                                touched={touched.parentEmail}
                                            />
                                        </Col>
                                        <Col>
                                            <TextInput
                                                id="confParentEmail"
                                                type="text"
                                                label="Confirm Parent Email"
                                                placeholder="Enter Text"
                                                error={errors.confParentEmail}
                                                value={values.confParentEmail}
                                                onChange={handleChange}
                                                onBlur={setFieldTouched}
                                                touched={touched.confParentEmail}
                                            />
                                        </Col>
                                    </Row>
                                    :
                                    null}
                                <TextInput
                                    id="phoneNumber"
                                    type="tel"
                                    label="Phone Number"
                                    placeholder="Enter Text"
                                    error={errors.phoneNumber}
                                    value={values.phoneNumber}
                                    onChange={handleChange}
                                    onBlur={setFieldTouched}
                                    touched={touched.phoneNumber}
                                />
                                <br></br>
                                <h4>Payment</h4>
                                <div className="card card-body bg-light">
                                    <Row>
                                        <Col>
                                            <Row>
                                                <Col>
                                                    <CCTextInput
                                                        id="CCNumber"
                                                        type="number"
                                                        placeholder="Card Number"
                                                        error={errors.CCNumber}
                                                        value={values.CCNumber}
                                                        onChange={setFieldValue}
                                                        onBlur={setFieldTouched}
                                                        touched={touched.CCNumber}
                                                        CCField="number"

                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <CCTextInput
                                                        id="CCFirstName"
                                                        type="text"
                                                        placeholder="First Name"
                                                        error={errors.CCFirstName}
                                                        value={values.CCFirstName}
                                                        onChange={setFieldValue}
                                                        onBlur={setFieldTouched}
                                                        touched={touched.CCFirstName}
                                                        CCField="name"
                                                    />
                                                </Col>
                                                <Col>
                                                    <CCTextInput
                                                        id="CCLastName"
                                                        type="text"
                                                        placeholder="Last Name"
                                                        error={errors.CCLastName}
                                                        value={values.CCLastName}
                                                        onChange={setFieldValue}
                                                        onBlur={setFieldTouched}
                                                        touched={touched.CCLastName}
                                                        CCField="name"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <CCTextInput
                                                        id="CCExpiration"
                                                        type="text"
                                                        placeholder="MM/YY"
                                                        error={errors.CCExpiration}
                                                        value={values.CCExpiration}
                                                        onChange={setFieldValue}
                                                        onBlur={setFieldTouched}
                                                        touched={touched.CCExpiration}
                                                        CCField="expiry"
                                                    />
                                                </Col>
                                                <Col>
                                                    <CCTextInput
                                                        id="CCCode"
                                                        type="text"
                                                        placeholder="CVC"
                                                        error={errors.CCCode}
                                                        value={values.CCCode}
                                                        onChange={setFieldValue}
                                                        onBlur={setFieldTouched}
                                                        touched={touched.CCCode}
                                                        CCField="cvc"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <TextInput
                                                        id="CCAddress"
                                                        type="text"
                                                        placeholder="Billing Address"
                                                        error={errors.CCAddress}
                                                        value={values.CCAddress}
                                                        onChange={handleChange}
                                                        onBlur={setFieldTouched}
                                                        touched={touched.CCAddress}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <TextInput
                                                        id="CCCity"
                                                        type="text"
                                                        placeholder="City"
                                                        error={errors.CCCity}
                                                        value={values.CCCity}
                                                        onChange={handleChange}
                                                        onBlur={setFieldTouched}
                                                        touched={touched.CCCity}
                                                    />
                                                </Col>
                                                <Col>
                                                    <TextInput
                                                        id="CCState"
                                                        type="text"
                                                        placeholder="State"
                                                        error={errors.CCState}
                                                        value={values.CCState}
                                                        onChange={handleChange}
                                                        onBlur={setFieldTouched}
                                                        touched={touched.CCState}
                                                    />
                                                </Col>
                                            </Row> <Row>
                                                <Col>
                                                    <TextInput
                                                        id="CCZip"
                                                        type="text"
                                                        placeholder="Zipcode"
                                                        error={errors.CCZip}
                                                        value={values.CCZip}
                                                        onChange={handleChange}
                                                        onBlur={setFieldTouched}
                                                        touched={touched.CCZip}
                                                    />
                                                </Col>
                                                <Col>
                                                    <TextInput
                                                        id="CCCountry"
                                                        type="text"
                                                        placeholder="Country"
                                                        error={errors.CCCountry}
                                                        value={values.CCCountry}
                                                        onChange={handleChange}
                                                        onBlur={setFieldTouched}
                                                        touched={touched.CCCountry}
                                                    />
                                                </Col>
                                            </Row>
                                            <br></br>
                                        </Col>
                                        <Col >
                                            <br></br>
                                            <Cards
                                                number={values.CCNumber}
                                                name={values.CCFirstName + " " + values.CCLastName}
                                                expiry={values.CCExpiration.replace(/ /g, '')}
                                                cvc={values.CCCode}
                                                focused={values.focused}
                                                acceptedCards={['visa', 'mastercard', "discover"]}
                                            />
                                            <br />
                                            <Col>
                                                <Row className="d-flex justify-content-center">
                                                    <img
                                                        className="d-flex justify-content-center"
                                                        src={process.env.PUBLIC_URL + '/visa.jpg'}
                                                        alt="Visa"
                                                    />     <img
                                                        className="d-flex justify-content-center"
                                                        src={process.env.PUBLIC_URL + '/mastercard.gif'}
                                                        alt="Mastercard"
                                                    />     <img
                                                        className="d-flex justify-content-center"
                                                        src={process.env.PUBLIC_URL + '/discover.gif'}
                                                        alt="Discover"
                                                    />
                                                </Row>
                                            </Col>


                                        </Col>
                                    </Row>
                                </div>

                                <Field
                                    component={Checkbox}
                                    name="confirmCheck"
                                    id="confirmCheck"
                                    value={values.confirmCheck}
                                />

                                {submitCount === 0 ? null : <div>
                                    {
                                        Object.keys(errors).length > 0 ?
                                            <div>
                                                Please correct the following errors and resubmit:
                                                <br></br>
                                            </div>
                                            :
                                            null
                                    }

                                    {
                                        Object.keys(errors).map(error => {
                                            if (errors[error] && errors[error].value) {
                                                return (
                                                    errors[error].value);
                                            }
                                            else {
                                                return (
                                                    errors[error]
                                                );
                                            }
                                        }).map((error, index) => {
                                            return <div key={index} className="input-feedback">{error}</div>;

                                        })
                                    }

                                </div>}

                                <br></br>
                                <button type="submit" disabled={isSubmitting}>
                                    Submit
                                </button>
                            </form>
                        );
                    }}
                </Formik>
            </div >
        );
        return (<div className="holder" >
            {this.state.showConfirmation ?
                <div>
                    <Alert variant="success">
                        <strong>Payment successfully processed!</strong>
                    </Alert>
                    <p>Thanks for signing up. Once we get confirmation from the RMV, we will email you to confirm your Road Test date. </p>
                    <a href="/" className="btn btn-primary regButton" role="button">Return Home</a>
                </div> :
                <div className="holder">
                    <h2>Parkway Driving School Road Test Sign Up</h2>
                    <div>
                        <h4>Under 18 Students</h4>
                        <ul>
                            <li>Anyone under 18 must have their permit for 6 months before taking a road test.</li>
                            <li><strong className="error">Parkway students can sign up for their test at any time, but lessons must be completed at least two weeks before their test date.</strong></li>
                            <li>If you are <strong className="error">NOT</strong> a Parkway student, driver education must be complete and a completion certificate must be on file with the RMV <strong className="error">21 days</strong> before a road test appointment.</li>
                        </ul>
                        <h4>Road Test Dates</h4>
                        <ul>
                            <li>Dates are assigned by the RMV when Examiners are available.</li>
                            <li>You will receive the time of the test one week before.</li>
                        </ul>
                        <h4>General Information</h4>
                        <ul>
                            <li><strong className="refundwarn" >Due to the limited test slots, there are NO Refunds or cancellations for a road test for any reason including illness, emergency, day of the test, or rejection by the RMV examiner.</strong></li>
                            <li>You will receive a confirmation email immediately after payment.</li>
                            <li>If you arrive for your road test without your permit, glasses or proper footware, you will not be allowed to test.</li>
                            <li>Parkway does not provide translators. If needed, please bring your own translator for your road test.</li>
                        </ul>
                    </div>
                    {regFormContent}
                </div>}
            <Modal
                show={this.state.loading}
                onHide={this.handleHide}
                dialogClassName="custom-modal"
            >
                <Modal.Body>
                    <Image src={process.env.PUBLIC_URL + '/car-loading.gif'} className="img-fluid d-block mx-auto" />
                    <br></br>
                    <p className="center">We're working on processing your order.</p>
                    <p className="center">Please Wait.</p>
                </Modal.Body>
            </Modal>
        </div>
        );
    }
}

export default RegistrationForm;